module.exports = __webpack_public_path__ + "media/comboSmash-preview@sm-ce2446c923a6d58d377eb0d92fd15c41.jpg";